export const DEX_TYPE = {
  SGBUILDEX: 'sgbuildex',
  SGTRADEX: 'sgtradex',
  SGHEALTHDEX: 'sghealthdex',
}
